import { ButtonHTMLAttributes, FC } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  label?: string;
  iconSrc?: string;
  loading?: boolean;
}

const CommonButton: FC<Props> = ({
  className,
  label,
  iconSrc,
  disabled,
  loading,
  onClick,
  ...props
}) => {
  return (
    <button
      className={`btnC ${className}`}
      disabled={disabled}
      {...props}
      onClick={onClick}
    >
      {label}
      {iconSrc ? <img src={iconSrc} alt="icon" className="icon-btn" /> : null}
      {loading ? <div className="spinner-border"></div> : null}
    </button>
  );
};

export default CommonButton;
